const domainNewPrefix = 'new.';

export { domainNewPrefix };
